module.exports = __webpack_public_path__ + "img/edit-ad-image.dc877949.png";